import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { UtilitysService } from 'src/app/services/utilitys/utilitys.service';
import { ModalService } from '../modal.service';
import { ApiService } from 'src/app/services/api/api.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { EventsService } from 'src/app/services/events.service';

@Component({
  selector: 'app-modal-redeem-information',
  templateUrl: './modal-redeem-information.component.html',
  styleUrls: ['./modal-redeem-information.component.scss']
})
export class ModalRedeemInformationComponent implements OnInit {
  @ViewChild('redeemInformationModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  myProfile: any = {};
  isShow = false;
  reward: any = {};
  selectedDeliveryType = 1;
  isMainAddress = false;
  operationUnit : any =[];
  deliveryName: string = "";
  deliveryPhone: string = "";
  deliveryAddress : string = "";
  deliveryOperationUnit : number = 0;

  constructor(private modalServ: ModalService,
    private modalService: BsModalService,
    private utility: UtilitysService,
    private api: ApiService,
    private ngxLoading: NgxUiLoaderService,
    private noti: NotificationService,
    private ev: EventsService
    ) { }

  ngOnInit() {
    this.modalServ.onRedeemInformation.subscribe(req => {
      this.ngxLoading.start();
      this.getOperationUnit();
      this.api.getRedeemAddress().subscribe((res: any) => {
        if(res.Code == 200){
          if(res.Results){
            this.deliveryAddress = res.Results.DeliveryAddress;
            this.selectedDeliveryType =res.Results.DeliveryType;
            this.isMainAddress = true;
            if(res.Results.DeliveryType == 1){
                this.deliveryOperationUnit = res.Results.DeliveryOperationUnit;
            }
          }
        }
        this.ngxLoading.stopAll();
      }, (err) => {
        this.ngxLoading.stopAll();
      });
       this.myProfile = req.myProfile;
       this.reward = req.reward;
       if(this.myProfile)
          this.deliveryPhone = this.myProfile.Phone;
       if(this.myProfile){
        this.deliveryName = this.myProfile.FullName;
       }
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onRedeemInformationHide.subscribe(req => {
      this.hide();
    });
  }
  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
      // Workaround: Manually remove backdrop and body class to prevent stuck black screen
      setTimeout(() => {
        document.body.classList.remove('modal-open');
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
      }, 200);
    }
  }
  onDeliveryTypeChanges(event: any) {
     
  }
  isDisabled(){
     
    return false;
  }
  getOperationUnit(){
    
    this.api.getAllOperationUnit().subscribe((res: any) => {
      console.log(res);
      if(res.Code == 200){
        if(res.Results){
          this.operationUnit = res.Results;
        }
      }
      
    }, (err) => {
      console.log(err);
    });
  }
  confirm()
  {

    if(this.selectedDeliveryType == 2 && this.deliveryAddress.trim() == ""){
        return false;
    }
    if(this.selectedDeliveryType == 1 && this.deliveryOperationUnit == 0){
      
      return false;
   }
   if(this.selectedDeliveryType == 1){
    var selOperationUnit=  this.operationUnit.find( x => x.Id == this.deliveryOperationUnit);
    if(selOperationUnit != null && selOperationUnit != undefined){
      this.deliveryAddress = selOperationUnit.Name
    }
   }
    const body = {
      'rewardId': this.reward.RewardID,
      'deliveryName': this.deliveryName,
      'deliveryPhone': this.deliveryPhone,
      'deliveryType': this.selectedDeliveryType,
      'deliveryOperationUnit': this.deliveryOperationUnit,
      'deliveryAddress': this.deliveryAddress,
      'isMainAddress':this.isMainAddress
    };
    
    this.ngxLoading.start()
    this.api.rewardRedeem(body).subscribe((res: any) => {
      this.noti.notificationCount();
      this.hide();
      this.ngxLoading.stopAll();

      setTimeout(() => {
        if(res.Code == 200){
          this.modalServ.onRedeemed.emit({status: 'success', message: res.Message});
          this.ev.onReloadMyProfile.emit();
        } else {
          this.modalServ.onRedeemedSuccess.emit({status: 'fail', errorMsg: res.Message});
        }
      }, 500);
    }, (err) => {
      this.modalServ.onRedeemedSuccess.emit({status: 'fail', errorMsg: 'Internal Error.'});
      console.log(err);
      this.ngxLoading.stopAll();
    });
  }
}
